export const contentKeys = {
  getOne: (contentConnectionId: number | string, contentIdentifier: string) => [
    "content",
    contentConnectionId,
    contentIdentifier,
  ],
};
